import { render, staticRenderFns } from "./Donate.vue?vue&type=template&id=3d4d7b7a"
import script from "./Donate.vue?vue&type=script&lang=js"
export * from "./Donate.vue?vue&type=script&lang=js"
import style0 from "./Donate.vue?vue&type=style&index=0&id=3d4d7b7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports